import React, { useState } from 'react';
import FullModal from './FullModal';
import { Building2 } from 'lucide-react';
import { useOrganization } from '../../hooks/useOrganization';
import { InputTextField } from '../Input/InputTextField';
import { Button } from '@mui/material';
import { LoaderSpinner } from './LoaderSpinner';
import { toast } from 'react-hot-toast';
import { successToastConfig, dangerToastConfig } from '../../utils/data';


const CreateEmpGrp = ({invite, onClose}) => {
  const { createEmpGrp, accountSelected } = useOrganization();
  const [empName, setEmpName] = useState('');
  const [memberCount, setMemberCount] = useState('');
  const [inputStyle, setInputStyle] = useState({});
  const [loading, setLoading] = useState(false);

  const handleUpdate = (field) => (value) => {
    if (field === "empName") {
      setEmpName(value);
    } else if (field === "memberCount") {
      setMemberCount(value);
    }
  };

  const handleCreate = async () => {
    if(empName.trim() === '' || memberCount.trim() === ''){
        setInputStyle({border: '1px solid red'});
        return;
    };
    setLoading(true);
    const res = await createEmpGrp({ name: empName, teamMemberCount: parseInt(memberCount), accountId: accountSelected });
    
    if(res.status === 200){
        toast('Employer group created successfully', successToastConfig);
        onClose();
    } else {
        toast('Something went wrong. Please try again', dangerToastConfig);
    }
    setLoading(false);
  };

  return (
    <FullModal onClose={onClose}>
        <div className="flex-row align-center">
            
            <Building2 size={24} style={{ marginRight: 10, color: 'var(--brand-blue)' }} />
        </div>

        <InputTextField
            onChange={handleUpdate("empName")}
            placeholder='Name of Employer Group'
            value={empName}
            style={empName === '' ? inputStyle : {}}
        />
        <InputTextField
            onChange={handleUpdate("memberCount")}
            placeholder='Team members count'
            value={memberCount}
            style={memberCount === '' ? inputStyle : {}}
        />
        <div style={{width: '100%',marginTop: 16}} className="flex-row align-center">
            <Button
                variant="contained" 
                color="primary"
                onClick={handleCreate}
            >
                Create
            </Button>
            { loading && <LoaderSpinner style={{marginLeft: 20}} absolute={false} /> }
        </div>
        
    </FullModal>
  );
};

export default CreateEmpGrp;